<template>
  <Layout>
    <div class="store">
      <div class="bg-white">
        <div class="container">
          <nav class="wrapper-crumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/report"><i class="fa fa-home"></i></a>
              </li>
              <li class="breadcrumb-item">
                <a href="/report/search">Daftar Laporan</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ data.title || "" }}
              </li>
            </ol>
          </nav>

          <div class="global-slider">
            <div class="slider">
              <carousel :autoplay="true" :perPage="1">
                <slide>
                  <div class="slide-image">
                    <img :src="data.img" />
                  </div>
                </slide>
              </carousel>
            </div>
          </div>

          <div v-if="data.core_type == 'campaign'" class="information">
           
            <div class="row mb-3">
              <div class="col-md-6">
                <span class="title">Target</span>
              </div>
              <div class="col-md-6">
                <span class="value price">Rp {{ data.target || 0 }}</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="`width: ${data.now_value ? (data.now_value / data.target_value) * 100 : 0}%`"
                    :aria-valuenow="`${data.now_value ? (data.now_value / data.target_value) * 100 : 0}`"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div> 
            <div class="row mb-3">
              <div class="col-md-6">
                <span class="title">Dana Terkumpul</span>
              </div>
              <div class="col-md-6">
                <span class="value price">Rp {{ data.now || 0 }}</span>
              </div>
            </div>
          </div>
          <div class="description mt-3">
            <h5>Informasi Program</h5>
            <template v-if="data.desc">
              <div v-html="data.desc"></div>
            </template>
          </div>
        </div>
      </div>

      <div class="bg-grey">
        <div class="container">
          <div class="report">
            <h5>Informasi Penyaluran</h5>
          </div>
        </div>
        <div class="container">
          <div class="accordion" id="isoman">
            <template v-if="reportPenyaluran.length < 1">
              <div class="nodata-penyaluran">
                Belum ada laporan pada program ini.
              </div>
            </template>
            <template v-else>
              <div class="accordion-item" v-for="(reportPenyaluran, index) in reportPenyaluran" :key="index">
                <h2 class="accordion-header" :id="`isomanHeading${index}`">
                  <button
                    class="accordion-button accordion-laporan"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#panelIsoman-${index}`"
                    aria-expanded="true"
                    :aria-controls="`panelIsoman-${index}`"
                  >
                    <strong>
                      {{ reportPenyaluran.implement_date ? formatDate(reportPenyaluran.implement_date) : "" }}
                      - {{ reportPenyaluran.name || "" }}
                    </strong>
                  </button>
                </h2>
                <div
                  :id="`panelIsoman-${index}`"
                  class="accordion-collapse collapse show"
                  aria-labelledby="isomanHeading1"
                >
                  <div class="accordion-body">
                    <div class="wrapper-slider">
                      <div class="slider-report">
                        <div v-if="reportPenyaluran.gallery.length > 0">
                          <silent-box :gallery="reportPenyaluran.gallery" />
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div class="content">
                      <div style="border-bottom: 1px solid #ddd; margin-bottom: 20px; padding-bottom: 20px;">
                        <div class="row">
                          <div class="col-md-12">
                            <span class="source-title">Sumber Pelapor:</span>
                            <span class="source-content">
                              {{ reportPenyaluran.source || "" }}
                            </span>
                            <br />
                            <br />
                            <span class="source-title">Penanggung Jawab:</span>
                            <span class="source-content">
                              {{ reportPenyaluran.pic_fullname || "" }}
                            </span>
                            <br />
                            <br />
                            <span class="source-title">Email:</span>
                            <span class="source-content">
                              {{ reportPenyaluran.pic_email || "" }}
                            </span>
                            <br />
                            <br />
                            <span class="source-title">Nomor Handphone:</span>
                            <span class="source-content">
                              {{ reportPenyaluran.pic_number || "" }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <template v-if="reportPenyaluran.description">
                        <div v-html="reportPenyaluran.description"></div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../views/layouts/Index.vue";
import { Carousel, Slide } from "vue-carousel";
import axios from "../../utils/masjedapi";
import moment from "moment";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
  },
  data() {
    return {
      data: [
        {
          id: "1",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "2",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "3",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "4",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "5",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "6",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "7",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
        {
          id: "8",
          title: "Infaq besama Lembaga Wakaf - Majelis Ulama ...",
          terkumpul: 280000000,
          berakhir: "16 Juni 2022",
        },
      ],
      dataLoader: false,
      data: [],
      reportPenyaluran: [],
    };
  },
  created() {
    const { id } = this.$route.params;
    this.fetch(id);
  },
  methods: {
    async fetch(id = "") {
      this.dataLoader = true;
      let url = `/store/detail`;
      if (id) url = url + `?id=${id}`;
      const terbaru = await axios.get(url);
      const { data } = terbaru.data;
      this.data = data;
      this.dataLoader = false;

      this.fetchReportPenyaluran(data.laporan_code);
    },
    async fetchReportPenyaluran(report_code = "") {
      let url = `/laporan/detail`;
      if (report_code) url = url + `?code=${report_code}`;
      const laporan = await axios.get(url);
      const { data } = laporan.data;
      console.log(data);
      this.reportPenyaluran = data.detail || [];
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin center {
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

@mixin mobile-s {
  @media screen and (max-width: 320px) {
    @content;
  }
}

@mixin mobile-m {
  @media screen and (min-width: 321px) and (max-width: 374px) {
    @content;
  }

  @media screen and (min-width: 375px) and (max-width: 480px) {
    @content;
  }
}

@mixin mobile-l {
  @media screen and (min-width: 481px) and (max-width: 768px) {
    @content;
  }
  @media screen and (min-width: 769px) and (max-width: 820px) {
    @content;
  }
}

@mixin tablet {
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    @content;
  }
}

.icon-search {
  width: 18px;
}

.information {
  padding: 20px 0px;
  .value {
    display: block;
    text-align: right !important;
  }

  .price {
    color: #64dd17;
    font-weight: bold;
  }
}

.wrapper-slider {
  height: 250px !important;

  @include mobile-s() {
    height: 100px !important;
  }

  @include mobile-m() {
    height: 100px !important;
  }
  .slider-report {
    padding: 0px !important;

    img {
      border-radius: 5px;
      width: auto !important;
      height: 350px !important;

      @include mobile-s() {
        height: 100px !important;
      }

      @include mobile-m() {
        height: 120px !important;
      }
    }
  }
}

.accordion-item {
  h2 {
    padding: 20px 0px;
  }
  .accordion-button {
    background: #fff !important;
    padding: 15px;
    border-radius: 10px !important;
    @include mobile-s() {
      border-radius: 10px !important;
    }
  }
  .slider {
    padding: 0px !important;
    border: 1px solid black;
  }

  .content {
    padding: 20px 0px;
  }
}

.nodata-penyaluran {
  padding: 20px 0px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
}

.wrapper-crumb {
  padding-top: 30px;
  ol li a {
    text-decoration: none;
    color: #333;
  }
}

.source-title {
  font-size: 12px;
  display: block;
  margin-bottom: 10px;
}

.source-content {
  line-height:20px;
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
